<div class="full-page-container">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="'events.page.title' | translate"></fgb-banner>
  </div>

  <fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

  <div class="container mt-4">
    <fgbcl-marketplace-list
      [isList]="true"
      [marketplaceItemTypes]="[3, 5]"
      [eventItemView]="true"
      [defaultSort]="2"
      [showStatusFilter]="false"
    ></fgbcl-marketplace-list>
  </div>
</div>
